import infra from "../assets/images/webp/infra.webp";
import corporation from "../assets/images/webp/corporation.webp";
import invention from "../assets/images/webp/invention.webp";
import consultency from "../assets/images/webp/consultency.webp";
import productiveWeek from "../assets/images/webp/productive-week.webp";
import holidaySeason from "../assets/images/webp/holiday-season.webp";
import galleryImageOne from "../assets/images/webp/gallery-image-one.webp";
import galleryImageTwo from "../assets/images/webp/gallery-image-two.webp";
import galleryImageThree from "../assets/images/webp/gallery-image-three.webp";
import bgAbout from "../assets/images/webp/hero-about-main.webp";
import bgAboutInfra from "../assets/images/webp/hero-about-infra-main.webp";
import bgAboutConcult from "../assets/images/webp/hero-about-concult-main.webp";
import bgAboutCorporation from "../assets/images/webp/hero-about-corporation-main.webp";
import bgAboutInvitation from "../assets/images/webp/hero-about-invitation-main.webp";
import bgMission from "../assets/images/webp/hero-mission-main.webp";
import bgVision from "../assets/images/webp/hero-vision-main.webp";
import bgGallery from "../assets/images/webp/hero-gallery-main.webp";
import bgBlogs from "../assets/images/webp/hero-blogs-main.webp";
import bgContact from "../assets/images/webp/hero-contact-main.webp";

export const LOCAL_EMAIL = "info@makewayindia.com";
export const LOCAL_CONTACT_NO = "9253192531";

// arrays
export const NAV_LINK_LIST = [
  {
    title: "Home",
    url: "/",
  },
  {
    title: "Chairperson",
    lsUrl: "/chairperson",
    list: [
      {
        title: "Author",
        url: "/author",
      },
      {
        title: "Inventors",
        url: "/inventors",
      },
      {
        title: "Entrepreneur",
        url: "/about-entrepreneur",
      },
      {
        title: "Motivational Speaker",
        url: "/motivational-speaker",
      },
      {
        title: "Socialite",
        url: "/socialite",
      },
      {
        title: "Awards",
        url: "/achievements",
      },
      {
        title: "Interview",
        url: "/media-interview",
      },
      {
        title: "Articles",
        url: "/articles",
      },
    ],
  },
  {
    title: "About Us",
    lsUrl: "/about-us",
    list: [
      {
        title: "Make Way India Infra Pvt. Ltd.",
        url: "/india-infra",
      },
      {
        title: "Make Way India Corporation",
        url: "/india-corporation",
      },
      {
        title: "Make Way India Consultancy",
        url: "/india-consultancy",
      },
      {
        title: "Make Way India Invention Pvt. Ltd.",
        url: "/india-invention",
      },
    ],
  },
  {
    title: "Mission",
    url: "/mission",
  },
  {
    title: "Vision",
    url: "/vision",
  },
  {
    title: "Gallery ",
    url: "/gallery",
  },
  {
    title: "Buy Now ",
    url: "https://store.makewayindia.com/",
  },
  {
    title: "Blog ",
    url: "/blogs",
  },
  {
    title: "Collaboration",
    url: "/collaboration",
  },
  {
    title: "Contact Us ",
    url: "/contact-us",
  },
];
export const chairpersondata = [
  {
    title: "Author",
    url: "/author",
  },
  {
    title: "Inventors",
    url: "/inventors",
  },
  {
    title: "Entrepreneur",
    url: "/about-entrepreneur",
  },
  {
    title: "Motivational Speaker",
    url: "/motivational-speaker",
  },
  {
    title: "Socialite",
    url: "/socialite",
  },
  {
    title: "Awards",
    url: "/achievements",
  },
  {
    title: "Interview",
    url: "/media-interview",
  },
  {
    title: "Articles",
    url: "/articles",
  },
];

export const SERVICES_CARDS_DATA_LIST = [
  {
    title: "Make Way India Infra Pvt. Ltd.",
    description:
      "We specialize in creating sustainable infrastructure projects across India. Our notable projects include residential apartments, hotels, and farmhouses.",
    image: infra,
    url: "/india-infra",
  },
  {
    title: "Make Way India Corporation",
    description:
      'Promoting knowledge and creativity through initiatives like the book "Mind is King," inspiring thought leadership and self-development.',
    image: corporation,
    url: "/india-corporation",
  },
  {
    title: "Make Way India Invention Pvt. Ltd.",
    description:
      "Innovating for a better tomorrow with projects like the INJK water magnetic device and AI-based water Matka Project, focused on sustainable technology solutions.",
    image: invention,
    url: "/india-invention",
  },
  {
    title: "Make Way India Consultancy",
    description:
      "Offering exceptional consultancy services in digital marketing across PAN India and event/product launches worldwide, driving business growth.",
    image: consultency,

    url: "/india-consultancy",
  },
];
export const LATEST_NEWS_DATA_LIST = [
  {
    id: 1,
    title: "5 tips for business leaders for a productive week",
    description:
      "As a business leader, the way you begin your week sets the tone for the days ahead. Adopting positive habits and strategic planning can help you stay focused and productive.",
    date: "Jan 04, 2025",
    author: "admin",
    image: productiveWeek,
  },
  {
    id: 2,
    title: "Caring team during the holiday season",
    description:
      "The holiday season is a time for celebration, gratitude, and reflection. It is also a time to show appreciation for your team.",
    date: "Jan 04, 2025",
    author: "admin",
    image: holidaySeason,
  },
];

export const FOOTER_DATA_LIST = [
  {
    title: "Quick Links",
    list: [
      { subTitle: "Home", url: "/" },
      { subTitle: "About Us", url: "/about-us" },
      { subTitle: "Blog", url: "/blogs" },
      { subTitle: "Gallery", url: "/gallery" },
      { subTitle: "Contact", url: "/contact-us" },
      { subTitle: "Mission", url: "/mission" },
      { subTitle: "Vision", url: "/vision" },
    ],
  },
  {
    title: "Legal",
    list: [
      { subTitle: "Privacy Policy", url: "/privacy-policy" },
      { subTitle: "Privacy Settings", url: "/privacy-security" },
      { subTitle: "Terms and Conditions", url: "/terms-conditions" },
    ],
  },
  {
    title: "Contact",
    list: [
      {
        subTitle: LOCAL_CONTACT_NO,
        url: `tel:${LOCAL_CONTACT_NO}`,
        icon: "phone",
      },
      {
        subTitle: LOCAL_EMAIL,
        url: `mailto:${LOCAL_EMAIL}`,
        icon: "mail",
      },
      {
        subTitle:
          "Makeway india Opp.Rawalwasia Dharamshala, Bamashah Nagar Hisar",
        url: "",
        icon: "location",
      },
    ],
  },
];
export const FOOTER_DATA_LIST2 = [
  {
    title: "Quick Links",
    list: [
      { subTitle: "Home", url: "/" },
      { subTitle: "About Us", url: "/about-us" },
      { subTitle: "Blog", url: "/blogs" },
      { subTitle: "Gallery", url: "/gallery" },
      { subTitle: "Contact", url: "/contact-us" },
      { subTitle: "Mission", url: "/mission" },
      { subTitle: "Vision", url: "/vision" },
    ],
  },
  {
    title: "Legal",
    list: [
      { subTitle: "Privacy Policy", url: "/privacy-policy" },
      { subTitle: "Privacy Settings", url: "/privacy-security" },
      { subTitle: "Terms and Conditions", url: "/terms-conditions" },
    ],
  },
  {
    title: "Contact",
    list: [
      {
        subTitle: LOCAL_CONTACT_NO,
        url: `tel:${LOCAL_CONTACT_NO}`,
        icon: "phone",
      },
      {
        subTitle: LOCAL_EMAIL,
        url: `mailto:${LOCAL_EMAIL}`,
        icon: "mail",
      },
      {
        subTitle:
          "Corporate Office: #109, Business Park, Balaji Market, Industrial Area, Near ISL, Delhi Road, Hisar- 125 001 (Haryana) (India)",
        subTitle2:
          "MFG Unit: Plot No. 31, Rishi Vihar Colony, Near Satya Nagar, Near ISL, Delhi Road, Hisar- 125 001 (Haryana) (India)",
        url: "",
        icon: "location",
      },
    ],
  },
];

export const GALLERY_SLIDER_IMAGE_LIST = [
  galleryImageOne,
  galleryImageTwo,
  galleryImageThree,
  galleryImageOne,
  galleryImageTwo,
  galleryImageThree,
];
export const HERO_LIST = [
  {
    title: "Driving Innovation & Excellence",
    tag: "about us",
    url: "/about-us",
    image: bgAbout,
  },
  {
    image: bgAboutInfra,
    title: "Make Way India Infra Pvt. Ltd.",
    tag: "about us",
    url: "/about-us",
    key: "india-infra",
  },
  {
    image: bgAboutCorporation,
    title: "Make Way India Corporation",
    tag: "about us",
    url: "/about-us",
    key: "india-corporation",
  },
  {
    image: bgAboutConcult,
    title: "Make Way India Consultancy",
    tag: "about us",
    url: "/about-us",
    key: "india-consultancy",
  },
  {
    image: bgAboutInvitation,
    title: "Make Way India Invention Pvt. Ltd.",
    tag: "about us",
    url: "/about-us",
    key: "india-invention",
  },
  {
    image: bgMission,
    title: "Innovate. Grow. Succeed.",
    tag: "Mission",
    url: "our",
    key: "mission",
  },
  {
    image: bgVision,
    title: "Shaping the Future of Business",
    tag: "vision",
    url: "our",
    key: "vision",
  },
  {
    image: bgGallery,
    title: "Our Story in Pictures",
    tag: "Gallery",
    url: "gallery",
  },
  {
    image: bgBlogs,
    title: "Latest Updates & Insights",
    tag: "blog",
    url: "blogs",
  },
  {
    image: bgContact,
    title: "Contact Us",
    tag: "connect",
    url: "contact-us",
  },
];
export const DRIVING_BUSINESS_LIST = [
  "Enhance and grow your customer experience with tailored strategies.",
  "Leverage cutting-edge digital marketing strategies to expand your online presence.",
  "Explore new opportunities to expand your product or service range for broader market reach.",
];
